import { trimEnd } from 'lodash';

/**
 * @returns "1 item" or "3 items" (or just "item" with omitOne=true)
 */
export const itemQuantity = (
    quantity: number,
    singularItem: string,
    { omitOne = false }: { omitOne?: boolean } = {}
) => {
    if (quantity === 1 && omitOne) {
        return singularItem;
    }
    return `${quantity} ${singularItem}${quantity === 1 ? '' : 's'}`;
};

/**
 * Turns the first word of an imperative phrase (e.g. "Update the thing") into its present participle (e.g. "Updating the thing")
 */
export const presentParticipleFirst = (phraseStartingWithImperative?: string) => {
    if (!phraseStartingWithImperative) {
        return undefined;
    }
    const [verb, ...rest] = phraseStartingWithImperative.split(/\s/);
    return [`${trimEnd(verb, 'e')}ing`, ...rest].join(' ');
};
